module.exports = __webpack_public_path__ + "img/parter-avatar1.6ba2cf06.png";